import { Land } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('Land')

export default {
  route: 'land',
  class: Land,
  className: 'land',
  entityName: 'de.ul.fob.domain.land',
  tableSelectColumns: [
    {
      label: 'nameDE',
      field: 'nameDE'
    },
    {
      label: 'nameEN',
      field: 'nameEN'
    },
    {
      label: 'alpha2code',
      field: 'alpha2code'
    },
    {
      label: 'alpha3code',
      field: 'alpha3code'
    },
    {
      label: 'numericCode',
      field: 'numericCode'
    }
  ],
  fields: [
    Fields.String('alpha2code'),
    Fields.String('alpha3code'),
    Fields.String('nameDE'),
    Fields.String('nameEN'),
    Fields.String('numericCode')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/Land.js